import { render, staticRenderFns } from "./asidebarLanguage.vue?vue&type=template&id=32f14cd2&scoped=true&lang=pug&"
import script from "./asidebarLanguage.vue?vue&type=script&lang=js&"
export * from "./asidebarLanguage.vue?vue&type=script&lang=js&"
import style0 from "./asidebarLanguage.vue?vue&type=style&index=0&id=32f14cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f14cd2",
  null
  
)

export default component.exports